export enum PostalCodeType {
    GERMAN,
    OTHER,
}
